import React from 'react'

import CVImage from '../../dashboard/TalentPool/CVImage'

const UploadedCV = ({ pages, url }) => {
  return (
    <>
      {pages.map((page, index) => (
        <CVImage
          key={index}
          url={url?.slice(0, -3) + 'jpg'}
          pageNumber={page + 1}
        />
      ))}
    </>
  )
}

export default UploadedCV
